import {Button, Col} from "reactstrap";
import {createReferralCode} from "@store/actions/withdrawal";
import {useDispatch} from "react-redux";

const AtomReferralGenerate = () => {
    const dispatch = useDispatch();

    return (
        <Col className={"mt-4 text-center"}>
            <Button className="mt-2 rounded mr-2" color='info' outline onClick={() => dispatch(createReferralCode())}>
                Buat kode referral
            </Button>
        </Col>
    )
}

export default AtomReferralGenerate